module.exports = __webpack_public_path__ + "img/ea_bg7.7e422939.jpg";